/**
 * Serviço de Autenticação
 * Gerencia login, registro e autenticação via API
 */
import apiClient from "./api";

const authService = {
  /**
   * Faz login do usuário
   * @param {string} email - Email do usuário
   * @param {string} password - Senha do usuário
   * @returns {Promise<Object>} Dados do usuário e tokens
   */
  async login(email, password) {
    try {
      const response = await apiClient.post("/api/auth/login", {
        email,
        password,
      });


      // Salvar tokens no localStorage
      if (response.access_token) {
        localStorage.setItem("accessToken", response.access_token);
      }
      if (response.refresh_token) {
        localStorage.setItem("refreshToken", response.refresh_token);
      }

      return response;
    } catch (error) {
      console.error("[authService] Erro no login:", error);
      throw error;
    }
  },

  /**
   * Registra novo usuário
   * @param {string} email - Email do usuário
   * @param {string} password - Senha do usuário
   * @param {string} role - Role do usuário (opcional)
   * @returns {Promise<Object>} Dados do usuário criado
   */
  async register(email, password, role = "viewer") {
    try {
      const response = await apiClient.post("/api/auth/register", {
        email,
        password,
        role,
      });
      return response;
    } catch (error) {
      console.error("Erro no registro:", error);
      throw error;
    }
  },

  /**
   * Busca informações do usuário autenticado
   * @returns {Promise<Object>} Dados do usuário
   */
  async getCurrentUser() {
    try {
      const response = await apiClient.get("/api/auth/me");
      return response;
    } catch (error) {
      console.error("Erro ao buscar usuário:", error);
      throw error;
    }
  },

  /**
   * Renova o access token usando refresh token
   * @returns {Promise<string>} Novo access token
   */
  async refreshToken() {
    try {
      const refreshToken = localStorage.getItem("refreshToken");
      if (!refreshToken) {
        throw new Error("Refresh token não encontrado");
      }

      const response = await apiClient.post("/api/auth/refresh");
      
      if (response.access_token) {
        localStorage.setItem("accessToken", response.access_token);
      }

      return response.access_token;
    } catch (error) {
      console.error("Erro ao renovar token:", error);
      throw error;
    }
  },

  /**
   * Faz logout do usuário
   */
  logout() {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("loggedUser");
  },
};

export default authService;

